import { useState } from "react";
import { Box, Card, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { ShowChart } from "@mui/icons-material";
import { PRODUCTION_COLORS } from "../../productionPalette";
import "../../progressSection.css";
import "./modernEvolutionChart.css";

const SERIES = [
  { dataKey: "Sourcing", label: "Sourcé", color: PRODUCTION_COLORS[0] },
  { dataKey: "Envois", label: "Envois", color: PRODUCTION_COLORS[1] },
  { dataKey: "Révélations", label: "Révélations", color: PRODUCTION_COLORS[2] },
  { dataKey: "Propales", label: "Propales", color: PRODUCTION_COLORS[3] },
  { dataKey: "Signatures", label: "Signatures", color: PRODUCTION_COLORS[4] },
];

const ModernEvolutionChart = ({ data }) => {
  const [selectedSeries, setSelectedSeries] = useState(null);

  const visibleSeries = SERIES.filter(
    (s) => selectedSeries === null || s.dataKey === selectedSeries
  ).map((s) => ({
    dataKey: s.dataKey,
    label: s.label,
    color: s.color,
    stack: "total",
    area: true,
    showMark: false,
    valueFormatter: (value) => `${value}`,
  }));

  return (
    <Card className="progressCard" elevation={0}>
      <Box className="progressHeaderLeft">
        <ShowChart className="progressHeaderIcon" />
        <Typography component="strong" className="progressHeaderTitle">
          ÉVOLUTION MENSUELLE SUR 12 MOIS
        </Typography>
      </Box>
      <Typography className="progressSubtitle" sx={{ marginTop: "6px !important" }}>
        Performances cumulées par segment d'activité
      </Typography>

      <Box className="evolutionLegend">
        {SERIES.map((s) => {
          const isDimmed = selectedSeries !== null && selectedSeries !== s.dataKey;
          return (
            <Box
              key={s.dataKey}
              className="evolutionLegendChip"
              onClick={() => setSelectedSeries((prev) => (prev === s.dataKey ? null : s.dataKey))}
              sx={{
                backgroundColor: isDimmed ? "transparent" : `${s.color}1F`,
                opacity: isDimmed ? 0.4 : 1,
              }}
            >
              <Box className="evolutionLegendDot" sx={{ backgroundColor: s.color }} />
              {s.label}
            </Box>
          );
        })}
      </Box>

      <LineChart
        dataset={data}
        xAxis={[{ scaleType: "point", dataKey: "month" }]}
        series={visibleSeries}
        height={300}
        grid={{ horizontal: true }}
        slotProps={{
          legend: { hidden: true },
          popper: { className: "profileEvolutionTooltipPopper" },
        }}
        sx={{
          "& .MuiAreaElement-root": {
            fillOpacity: 0.2,
          },
          "& .MuiLineElement-root": {
            strokeWidth: 2,
          },
          "& .MuiChartsAxis-line, & .MuiChartsAxis-tick": {
            stroke: "var(--profile-border)",
          },
          "& .MuiChartsGrid-line": {
            stroke: "var(--profile-border)",
          },
          "& .MuiChartsAxis-tickLabel": {
            fill: "var(--profile-ink-secondary)",
          },
        }}
      />
    </Card>
  );
};

export default ModernEvolutionChart;
